
const rafceToken = "__RAFCE__TOKEN__";

function setCurrentUser(token) {
  localStorage.setItem(rafceToken, token);
}

function getCurrentUser() {
  try {
    var user = localStorage.getItem(rafceToken);
    return user;
  } catch (error) {
    return null;
  }
}

function removeCurrentUser() {
  localStorage.removeItem(rafceToken);
}

const authService = {
  setCurrentUser,
  getCurrentUser,
  removeCurrentUser,
};

export default authService